<template>
    <a @click="clickHandler($event)" class="clickable" :href="this.url">
        <fa-icon :icon="this.getIcon()"></fa-icon> <slot>{{'Delete'}}</slot>
    </a>
</template>

<script>
export default {

  name: 'ConfirmButton',

  props: {
    url: String,
    icon: String,
    method: String,
    message: String
  },

  methods: {
    clickHandler: function(event) {
        event.preventDefault();

        const message = this.message || 'Are you sure you want to delete this?';

        if (confirm(message)) {
            this.submit();
        }
    },

    // Handle submit
    submit: function() {
        switch ((this.method || 'get').toLowerCase()) {
            case 'get':
                window.location.href = this.url;
                break;
            case 'post':
            case 'delete':
            case 'put':
                const form = generateform();
                form.submit();
                break;
            default:
                console.log('Method not accepted: ', this.method);
        }
    },

    // Submit via form, if method is not GET
    generateForm: function(method) {
        const form = $('<form>')
            .css('display', 'none')
            .attr('action', this.url)
            .attr('method', 'post');

        if (method !== 'get') {
            $('<input />')
                .attr('value', method.toUpperCase())
                .attr('name', '_method')
                .appendTo(form);
        }

        $('<input />')
            .attr('name', '_token')
            .val($('meta[name=csrf-token]').attr('content'))
            .appendTo(form);

        form.appendTo($('body'));
        return form;
    },

    // Get icon name
    getIcon: function() {
        return this.icon || 'trash-alt';
    }
  }
};
</script>
